import type { ComponentSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'
import { PRODUCT_PAGES, titleFields } from './_shared-library'

/** Heading with "Shop all" and a row of the newest products. */
export const schema: ComponentSchema = {
  type: 'new-arrivals',
  label: 'New arrivals',
  description: 'A swipe row of the newest products.',
  supportedPages: PRODUCT_PAGES,
  variants: [{ id: 'v1', label: 'Product row' }],
  commonFields: [...titleFields('New arrivals'), ...SECTION_STYLE_FIELDS],
}
